import script from "./WizardAssistance.vue?vue&type=script&setup=true&lang=ts"
export * from "./WizardAssistance.vue?vue&type=script&setup=true&lang=ts"

import "./WizardAssistance.vue?vue&type=style&index=0&id=28e3114a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28e3114a"]])

export default __exports__